import { HLM_ORDER_PATH } from "@features/assets-feature/routing/assetRouteSegments";

/** Service request detail page route, without its overlay splat. */
export const SERVICE_REQUEST_DETAIL_ROUTE =
  "/:prefix?/support-center/requests/:id";

/** Routed overlay segments on the service request detail page. */
export const SERVICE_REQUEST_SEGMENTS = {
  attachment: "attachment",
} as const;

export const SERVICE_REQUEST_ATTACHMENT_PATH = `${SERVICE_REQUEST_SEGMENTS.attachment}/:attachmentId`;

export const serviceRequestDetailOverlayPaths = (base: string): string[] => [
  `${base}/${SERVICE_REQUEST_ATTACHMENT_PATH}`,
  `${base}/${HLM_ORDER_PATH}`,
];
